import React, { Component } from 'react';

import {
  Link
} from "react-router-dom";
import { _updateNotificationToken } from '../api/Common';
import { _logOut, _clearAllInterval, _getLoginStatus } from './Constants';
import DoctorsSideMenu from './DoctorsSideMenu';
import HospitalSideMenu from './HospitalSideMenu';
import withNavigateHook from './withNavigateHook';
let $ = window.$;
class HospitalHeader extends Component {

  /**
  * 
  * @param {*} props 
  */
  constructor(props) {
    super(props);
    this.action = window.location.pathname.split("/").pop();
    this.state = {
      user: {}
    }

  }

  /**
  * 
  */
  componentDidMount = async () => {
    let res = await _getLoginStatus();

    if (res['status']) {
      await this.setState({
        user: res.data
      });
    }
   
    await _clearAllInterval();
  }



  /**
   * 
   * @param {*} param 
   */
  _handleLogout = async (e) => {
    e.preventDefault();
    await _updateNotificationToken('',this.state.user.id,'Doctor','logout')
    let res = await _logOut('Doctor');
    this.props.navigation(res);
  }

  /**
     * 
     * @param {*} e 
     */
  _goBack = (e) => {
    e.preventDefault();
    this.props.navigation(-1)
  }


  /**
   * 
   */
  _closeSideNav = () => {
    $('.sidenav').sidenav('close')
  }

  render() {

    return (

      <React.Fragment>
        <header>
          {
            this._closeSideNav()
          }
         
          <div className="oparchee-bg1">

            <div className="container">

              <div className="row">

                <div className="col s8">

                  <div className="loginTxt left-align">
                    {
                      this.action != "doctors-dashboard" && this.action != "doctors-history" && this.action != "doctors-equipment" && this.action != "doctors-account" 
                      && this.action != "doctor-list" ?
                        <React.Fragment>
                          <Link to="/" onClick={(e) => { this._goBack(e) }}> <i className="material-icons">arrow_back</i>  </Link>
                          {this.action.replaceAll('-', ' ').replaceAll('doctors', '').replaceAll('doctor', '').toUpperCase()}
                        </React.Fragment>
                        :
                        <a href="#!" data-target="slide-out" className="button-collapse sidenav-trigger show-on-large"><i className="material-icons">menu</i></a>
                    }
                   
                  </div>

                </div>

                <div className="col s4">

                  <div className="skipTxt right-align">
                    <Link to="/doctors-dashboard" ><i className="material-icons" title="Home">home</i></Link> 
                    {/* <Link to="/" onClick={(e) => { this._handleLogout(e) }}>Logout</Link> */}
                  </div>

                </div>

              </div>

            </div>

          </div>

        </header>
        <HospitalSideMenu user={this.state.user} />
      </React.Fragment>
    );
  }
}

export default withNavigateHook(HospitalHeader);
